import { ModuleSidebar } from "@/components/modules/ModuleSidebar";
import { MODULES } from "@/lib/modules/registry";

export function MilitaresSidebar() {
  return <ModuleSidebar config={MODULES.militares} />;
}
